import styled from "styled-components";
import ButtonComponent from "../Button/Button";

export const Button = styled(ButtonComponent)`
  font-weight: normal;
`;
